module.exports = __webpack_public_path__ + "ci_vendor_nagios_xi.7037f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_nagios_xi.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_nagios_xi.svg
// module chunks = main